module.exports = __webpack_public_path__ + "img/squarespace.bb94b5f2.svg";